<div class="d-flex justify-content-center fw-bold fs-4 l-preview-title">
    {{ 'contractModifications.wizard.preview.title' | translate }}
</div>
<div class="d-flex flex-column justify-content-start pb-3 mb-4">
    <div class="l-item-section">
        <span class="l-section-title">
            {{'contractModifications.wizard.preview.contractAndModificationType' | translate}}
        </span>
        <div HJSuppress class="section-content">
            <ul>
                <li>{{ contractModificationRequest?.contractName }}</li>
                <li
                *ngIf="
                    contractModificationRequest?.dictionaryModificationTypeId ===
                    DICTIONARY_CONTRACT_MODIFICATION_TYPE.REIMBURSEMENT?.id;
                    else otherContractModification">
                {{ contractModificationRequest?.dictionaryReimbursementTypeName }}
                </li>
                <ng-template #otherContractModification>
                    <li>
                        {{ contractModificationRequest?.dictionaryModificationTypeName }}
                    </li>
                </ng-template>
            </ul>
        </div>
    </div>
    <ng-container>
        <div *ngIf="(contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.OTHER?.id)"
            class="l-item-section"
        >
            <span class="l-section-title">
                {{ 'contractModifications.wizard.preview.modificationType' | translate }}
            </span>
            <div HJSuppress class="section-content">
                <ul>
                    <li>{{ otherModificationType }}</li>
                </ul>
                <button
                    class="btn edit-btn custom-edit-btn ms-auto"
                    (click)="editWizardStepHandler(wizardStepsEnum.ContractModification_ChooseContractAndModificationType)">
                    <i class="app-icon icon icon-edit icon-xl"></i>
                </button>
            </div>
        </div>
        <div
            *ngIf="(contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.OTHER?.id) 
            || (contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.FINANCING_OFFER?.id) 
            || (contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.COMPLAINTS?.id) 
            || (contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.CONTRACT_ASSIGNMENT?.id)"
            class="l-item-section">
            <span class="l-section-title">
            {{ 'contractModifications.wizard.preview.description' | translate }}
            </span>
            <div HJSuppress class="section-content">
            <ul>
                <li>{{ description }}</li>
            </ul>
            <button
                class="btn edit-btn custom-edit-btn ms-auto"
                (click)="editWizardStepHandler(wizardStepsEnum.ContractModification_ChooseContractAndModificationType)">
                <i class="app-icon icon icon-edit icon-xl"></i>
            </button>
            </div>
        </div>
    </ng-container>

    <ng-container 
        *ngIf="![DICTIONARY_CONTRACT_MODIFICATION_TYPE.OTHER?.id,
        DICTIONARY_CONTRACT_MODIFICATION_TYPE.FINANCING_OFFER?.id,
        DICTIONARY_CONTRACT_MODIFICATION_TYPE.COMPLAINTS?.id,
        DICTIONARY_CONTRACT_MODIFICATION_TYPE.CONTRACT_ASSIGNMENT?.id,
        DICTIONARY_CONTRACT_MODIFICATION_TYPE.DIRECT_DEBIT?.id,]
        .includes(contractModificationRequest.dictionaryModificationTypeId)"
    >
        <div class="l-item-section">
            <span class="l-section-title">{{ 'contractModifications.wizard.preview.reasonOfRequest' | translate }}</span>
            <div HJSuppress class="section-content">
                <ul>
                    <li>
                        {{ reasonOfRequest }}
                    </li>
                </ul>

                <button
                    class="btn edit-btn custom-edit-btn ms-auto"
                    (click)="editWizardStepHandler(wizardStepsEnum.ContractModification_Why)">
                    <i class="app-icon icon icon-edit icon-xl"></i>
                </button>
            </div>
        </div>
        <div class="l-item-section"
            *ngIf="DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id ===
            contractModificationRequest.dictionaryModificationTypeId">
            <span class="l-section-title">{{ 'contractModifications.wizard.preview.defermentPeriod' | translate }}</span>
            <div HJSuppress class="section-content">
                <ul>
                    <li>
                    {{ contractModificationRequest?.defermentPeriodStart | localizedDate: 'MMMM YYYY' }}
                    -
                    {{ contractModificationRequest?.defermentPeriodEnd | localizedDate: 'MMMM YYYY' }}
                    </li>
                </ul>

                <button
                    class="btn edit-btn custom-edit-btn ms-auto"
                    (click)="editWizardStepHandler(wizardStepsEnum.ContractModification_PostponePeriod)">
                    <i class="app-icon icon icon-edit icon-xl"></i>
                </button>
            </div>
        </div>

        <div class="l-item-section"
            *ngIf="contractModificationRequest.dictionaryModificationTypeId !==
            DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id">
            <span class="l-section-title">{{ 'contractModifications.wizard.preview.sourceOfPayment' | translate }}</span>

            <div HJSuppress class="section-content">
                <ul>
                    <li>
                        {{ contractModificationRequest?.dictionaryPaymentSourceName }}
                    </li>
                </ul>

                <button
                    class="btn edit-btn custom-edit-btn ms-auto"
                    (click)="editWizardStepHandler(wizardStepsEnum.ContractModification_PaymentSource)">
                    <i class="app-icon icon icon-edit icon-xl"></i>
                </button>
            </div>
        </div>

        <div class="l-item-section"
            *ngIf="contractModificationRequest.dictionaryModificationTypeId !==
            DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id">
            <span class="l-section-title">
                {{ 'contractModifications.wizard.preview.amountToBeReimbursed' | translate }}
                <span *ngIf="contractModificationRequest.dictionaryReimbursementTypeId ===
                    DICTIONARY_REIMBURSEMENT_TYPE.FULL_REIMBURSEMENT?.id">
                    {{ 'contractModifications.wizard.preview.additionalFees' | translate }}
                </span>
            </span>

            <div HJSuppress class="section-content">
                <ul>
                    <li>
                    {{ contractModificationRequest?.reimbursedAmount | number: '1.' }}
                    {{ contractModificationRequestHeader?.currencyCode }}
                    </li>
                </ul>

                <button
                    class="btn edit-btn custom-edit-btn ms-auto"
                    (click)="editWizardStepHandler(wizardStepsEnum.ContractModification_AmountPayInAdvance)"
                    [disabled]="
                    contractModificationRequest.dictionaryReimbursementTypeId ===
                    DICTIONARY_REIMBURSEMENT_TYPE.FULL_REIMBURSEMENT?.id">
                    <i class="app-icon icon icon-edit icon-xl"></i>
                </button>
            </div>
        </div>

        <div class="l-item-section"
            *ngIf="contractModificationRequest.dictionaryModificationTypeId ===
                DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id ||
                contractModificationRequest.dictionaryReimbursementTypeId ===
                DICTIONARY_REIMBURSEMENT_TYPE.PARTIAL_REIMBURSEMENT?.id">
            <ng-container *ngIf="contractModificationRequest.dictionaryModificationTypeId !==
                DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id;
                else INSTALLMENTDEFERALPREVIEW">
                <span class="l-section-title"
                    *ngIf="DICTIONARY_REIMBURSEMENT_TYPE.PARTIAL_REIMBURSEMENT?.id ===
                        contractModificationRequest.dictionaryReimbursementTypeId">
                        {{ 'contractModifications.wizard.preview.purposeOfReimbursement' | translate }}
                </span>
            </ng-container>
            <ng-template #INSTALLMENTDEFERALPREVIEW>
                <span class="l-section-title"
                    *ngIf="DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id ===
                    contractModificationRequest.dictionaryModificationTypeId">
                    {{ 'contractModifications.wizard.preview.purposeOfRequest' | translate }}
                </span>
            </ng-template>

            <div HJSuppress class="section-content">
                <ul>
                    <li>{{ purposeOfRequest }}</li>
                </ul>

                <button
                    class="btn edit-btn custom-edit-btn ms-auto"
                    (click)="editWizardStepHandler(wizardStepsEnum.ContractModification_RequestPurpose)">
                    <i class="app-icon icon icon-edit icon-xl"></i>
                </button>
            </div>
        </div>
    </ng-container>

    <div class="l-item-section">
        <span class="l-section-title">{{ 'contractModifications.wizard.preview.attachedFiles' | translate }}</span>

        <div HJSuppress class="section-content">
            <contract-modification-uploader
                [contractModificationRequest]="contractModificationRequest"
                [deleteFileHandler]="deleteFileHandler"
                [uploadFilesHandler]="uploadFilesHandler">
            </contract-modification-uploader>
        </div>
    </div>

    <div *ngIf="contractModificationRequest.requestTypeDescription" 
        class="d-flex justify-content-center">
        <div class="col-8">
            <div class=" d-flex justify-content-center">
                <i class="app-icon icon icon-warning-triangle-fill icon-xl me-2"></i>
                <span [innerHtml]="contractModificationRequest.requestTypeDescription"></span>
            </div>
        </div>
    </div>
</div>

<div class="d-flex justify-content-center">
    <button
        class="btn primary-btn"
        [disabled]="false"
        (click)="nextStepHandler(wizardStepsEnum.ContractModification_Preview)"
  >
        {{ 'contractModifications.wizard.sendRequestBtn' | translate }}
    </button>
</div>
